// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IL2x8","field":"styles_field__2c0B4","fieldCol":"styles_fieldCol__2vtCb","diffCol":"styles_diffCol__28JoI","diff":"styles_diff__3TupU"};